import React from 'react'
import styles from '../Names.module.css'

const Footer = () => {
  return (
    <div className={styles.footer}>
        פותח ע״י ה. א. פ. באהבה לעם ישראל❤️
    </div>
  )
}

export default Footer